require('../utils/polyfill-array-at');
const { marked } = require('marked');

(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('AccountFeedController', AccountFeedController);

    function AccountFeedController($rootScope, $scope, $stateParams, $state, $timeout, $window, $mdMedia, $transitions, config, events, model, account, messageService, utils, email, meeting, interactiongroup, datasources, $mdDialog, sfWalkthrough, sfDiscardDialog, filterService, helperFunctionsService, flagsService, $translate, $sce, $sanitize) {

        let thread = null;

        let controller = null;

        // Minimum time between UI refreshes while an AI answer is being streamed
        const STREAM_RENDER_INTERVAL = 50;

        let activeStreamRenderer = null;

        let timelineAiTour = null;

        $scope.showSpeedDialTooltips = !$window.touch; // They use hover states (aka mouseenter/...) and that just breaks on mobile so better to disable it
        $scope.apiUrl = config.apiUrl;
        $scope.model = model;
        $scope.message = {
            account: $stateParams.id
        };
        $scope.mode = config.mode;
        $scope.opened = false;
        $scope.feed = null;
        $scope.feedDetails = {};
        $scope.aiButtonsDisabled = false;
        $scope.isSameDay = utils.isSameDay;
        $scope.phoneCallAriaLabel = $translate.instant('phone call');
        $scope.meetingAriaLabel = $translate.instant('meeting');
        $scope.summarizeAriaLabel = $translate.instant('summarize');
        $scope.listNextStepsAriaLabel = $translate.instant('list next steps');
        $scope.askQuestionAriaLabel = $translate.instant('ask a question');
        $scope.menuAriaLabel = $translate.instant('menu');

        /**
         * Returns sanitized and trusted HTML for the empty-state message with link.
         * Translation is one full string including the <a> so translators get the whole sentence.
         *
         * @returns {Object} Trusted HTML for ng-bind-html
         */
        $scope.getNoInteractionsMatchHtml = function () {
            const raw = $translate.instant('Oops! No interactions match <a href="">the selected filters</a>.');
            return $sce.trustAsHtml($sanitize(raw));
        };

        /**
         * Delegates clicks on empty-state link to openFeedFilter (link is inside ng-bind-html).
         *
         * @param {Object} $event - Click event
         */
        $scope.handleNoInteractionsFilterClick = function ($event) {
            if ($event.target.tagName === 'A') {
                $event.preventDefault();
                $scope.openFeedFilter();
            }
        };

        /**
         * Format date with translated day and month names
         * Uses translation interpolation to allow different date formats per language
         * Format: "Monday, January 15, 2024" or "Monday, January 15" (if includeYear is false)
         *
         * @param {Date|String} dateInput
         * @param {Boolean} includeYear - Whether to include the year (default: true)
         * @returns {String}
         */
        $scope.formatTranslatedDate = function (dateInput, includeYear) {

            if (!dateInput) {
                return '';
            }

            if (angular.isUndefined(includeYear)) {
                includeYear = true;
            }

            const date = new Date(dateInput);

            const dayNames = [
                $translate.instant('Sunday'),
                $translate.instant('Monday'),
                $translate.instant('Tuesday'),
                $translate.instant('Wednesday'),
                $translate.instant('Thursday'),
                $translate.instant('Friday'),
                $translate.instant('Saturday')
            ];

            const monthNames = [
                $translate.instant('January'),
                $translate.instant('February'),
                $translate.instant('March'),
                $translate.instant('April'),
                $translate.instant('May'),
                $translate.instant('June'),
                $translate.instant('July'),
                $translate.instant('August'),
                $translate.instant('September'),
                $translate.instant('October'),
                $translate.instant('November'),
                $translate.instant('December')
            ];

            const dayName = dayNames[date.getDay()];
            const monthName = monthNames[date.getMonth()];
            const day = date.getDate();
            const year = date.getFullYear();

            if (includeYear) {
                return $translate.instant('{{dayName}}, {{monthName}} {{day}}, {{year}}', {
                    dayName,
                    monthName,
                    day,
                    year
                });
            }
            else {
                return $translate.instant('{{dayName}}, {{monthName}} {{day}}', {
                    dayName,
                    monthName,
                    day
                });
            }
        };

        $scope.getCalendarShareText = function (interaction) {

            if (interaction && !interaction.calendar_id) {
                return $translate.instant('This meeting has not been shared with the participants in your calendar invite.');
            }

            return $translate.instant('This meeting has been shared with the participants in your calendar invite.');
        };

        // Feed filter stuff
        $scope.filterOptions = ['Emails', 'Internal notes', 'Meetings', 'Phone calls', 'Link clicks', 'Website visits', 'Team updates'];
        $scope.feedFilterCustomers = {};
        $scope.allCustomersSelected = false;
        $scope.feedFilterInteractionTypes = {};
        $scope.allInteractionTypesSelected = false;
        $scope.aiMessageBox = false;
        $scope.aiQuestion = null;
        $scope.messageBoxPlaceholder = '';
        // Fill the feed filters like this since the data in the local storage looks different due to backwards compatibility reasons
        // We fill in the customers on init since we need to wait for the account to be able to fill
        filterService.getAccountFeedTypesFilter().forEach(function (option) {

            $scope.feedFilterInteractionTypes[option] = true;
        });
        setAllInteractionTypesSelected();

        let editingMessage = false;
        const typesMap = {
            'Emails': 'email',
            'Internal notes': 'message',
            'Meetings': 'meeting-live',
            'Phone calls': 'meeting-phone',
            'Link clicks': 'forward',
            'Website visits': 'webpage',
            'Team updates': ['user_added', 'user_removed', 'account_created']
        };

        if ($rootScope.history[$rootScope.history.length - 1].fromState.name.startsWith('accounts.')) {
            $rootScope.history.pop();
        }

        // By default md-menu-bar adds `md-dense` classes which we don't want so we remove them here
        // bit hacky but I tried a directive and it was always to quick
        $timeout(function () {

            return angular.element('.feed-filter md-menu-content').removeClass('md-dense');
        });

        if ($scope.account) {
            init();
            setFilterWatchers();
            $scope.$on(events.account.loaded, onAccountLoaded);
        }
        else {
            const unbindLoadedWatcher = $scope.$on(events.account.loaded, function (event, loadedAccount) {

                $scope.account = loadedAccount;
                unbindLoadedWatcher();
                init();
                setFilterWatchers();
                return $scope.$on(events.account.loaded, onAccountLoaded);
            });
        }

        $scope.$watch('message.body', function (newValue) {

            if (newValue) {
                model.disableFab = true;
            }
            else {
                model.disableFab = false;
            }
        });

        $scope.$on(events.refreshData, reload);
        $scope.$on(events.account.updated, function (evt, data) {

            if (data && !data.fetchFeed) {
                return;
            }

            return reload();
        });

        function setFilterWatchers() {
            /**
             * `init` relies on this watch to trigger, so take that in mind when making changes
             */
            $scope.$watch('feedFilterCustomers', function (newValue) {

                if (!newValue || !$scope.account) {
                    return;
                }

                setAllCustomersSelected();

                $timeout.cancel(thread);
                // Add a small time out to allow for quick (de)selecting of checkboxes
                // Without spamming requests
                thread = $timeout(function () {

                    // Convert new data structure to list of ids
                    const customerIds = [];
                    Object.entries($scope.feedFilterCustomers).forEach(function (entry) {

                        if (entry[1]) {
                            customerIds.push(entry[0]);
                        }
                    });

                    // Only store customer filter when not all customers are selected to prevent clogging local storage
                    if (customerIds.length === Object.keys($scope.feedFilterCustomers).length) {
                        filterService.setAccountFeedCustomersFilter($scope.account.id);
                    }
                    else {
                        filterService.setAccountFeedCustomersFilter($scope.account.id, customerIds);
                    }

                    // Reset `load more` button since we are basically doing a reload
                    $scope.everythingLoaded = false;
                    $scope.nothingMore = false;

                    // Use `get` not `reload` since `reload` uses the existing limit which does not make sense here
                    return get(undefined, false);
                }, $scope.feed === null ? 0 : 750);
            }, true);

            // Add watches for feed filters
            $scope.$watch('feedFilterInteractionTypes', function (newValue) {

                if (!newValue) {
                    return;
                }

                setAllInteractionTypesSelected();

                $timeout.cancel(thread);
                // Add a small time out to allow for quick (de)selecting of checkboxes
                // Without spamming requests
                thread = $timeout(function () {

                    // Convert new data structure to list of strings
                    const accountFeedFilter = [];
                    Object.entries($scope.feedFilterInteractionTypes).forEach(function (entry) {

                        if (entry[1]) {
                            accountFeedFilter.push(entry[0]);
                        }
                    });

                    filterService.setAccountFeedTypesFilter(accountFeedFilter);

                    // Reset `load more` button since we are basically doing a reload
                    $scope.everythingLoaded = false;
                    $scope.nothingMore = false;

                    // Use `get` not `reload` since `reload` uses the existing limit which does not make sense here
                    return get(undefined, false);
                }, $scope.feed === null ? 0 : 750);
            }, true);
        }

        function setAllInteractionTypesSelected() {

            // Comparing to filterOptions.length because feedFilterInteractionTypes doesn't always contain non selected items
            if ($scope.filterOptions.length === Object.values($scope.feedFilterInteractionTypes).filter((obj) => obj === true).length) {
                $scope.allInteractionTypesSelected = true;
            }
            else {
                $scope.allInteractionTypesSelected = false;
            }
        }

        $scope.selectOrDeselectAllInteractionTypes = function () {

            if ($scope.allInteractionTypesSelected) {
                Object.keys($scope.feedFilterInteractionTypes).forEach(function (key) {

                    $scope.feedFilterInteractionTypes[key] = false;
                });
            }
            else {
                // Using filterOptions because feedFilterInteractionTypes doesn't always contain non selected items
                $scope.filterOptions.forEach(function (key) {

                    $scope.feedFilterInteractionTypes[key] = true;
                });
            }
        };

        function setAllCustomersSelected() {

            if ($scope.account.customers.length === Object.values($scope.feedFilterCustomers).filter((obj) => obj === true).length) {
                $scope.allCustomersSelected = true;
            }
            else {
                $scope.allCustomersSelected = false;
            }
        }

        $scope.selectOrDeselectAllCustomers = function () {

            if ($scope.allCustomersSelected) {
                Object.keys($scope.feedFilterCustomers).forEach(function (key) {

                    $scope.feedFilterCustomers[key] = false;
                });
            }
            else {
                Object.keys($scope.feedFilterCustomers).forEach(function (key) {

                    $scope.feedFilterCustomers[key] = true;
                });
            }
        };

        // Listen to the account:loaded event to ensure we always have an up-to-date version of the account on scope
        // This ensures we can do stuff like mentioning a newly added team member
        // We also use this event to check if any customers got added to/removed from the account so we can update the account feed filter to include/exclude these contacts
        // Also make sure we call init before registering this function as an event handler to avoid timing issue with initializing the feed filter object
        function onAccountLoaded(event, loadedAccount) {

            const removedCustomerIds = (!$scope.account || !$scope.account.customers) ? [] : $scope.account.customers.filter(function (customer) {

                return !loadedAccount.customers.some(function (loadedAccountCustomer) {

                    return loadedAccountCustomer.id === customer.id;
                });
            }).map(function (customer) {

                return customer.id;
            });
            const addedCustomerIds = loadedAccount ? loadedAccount.customers.filter(function (customer) {

                return !$scope.account.customers.some(function (oldAccountCustomer) {

                    return oldAccountCustomer.id === customer.id;
                });
            }).map(function (customer) {

                return customer.id;
            }) : [];

            $scope.account = loadedAccount;

            removedCustomerIds.forEach(function (removedCustomerId) {

                $scope.feedFilterCustomers[removedCustomerId] = false;
            });

            addedCustomerIds.forEach(function (addedCustomerId) {

                $scope.feedFilterCustomers[addedCustomerId] = true;
            });
        }

        $scope.openFeedFilter = function () {

            return angular.element('.feed-filter .feed-filer_opener').click();
        };

        $scope.isAccountFeedFilterApplied = function () {

            return (!!$scope.account && !!getFilterContacts()) || filterService.isAccountFeedTypesFilterApplied();
        };

        $scope.goToAccountInfo = function () {

            if ($mdMedia('gt-sm')) {
                return $scope.$parent.toggleRight();
            }

            return $state.go('accounts.account.info');
        };

        $scope.openWebsite = helperFunctionsService.openWebsite;

        $scope.showPerson = function (person) {

            if (person.id) {
                if (person.type === 'user') {
                    return $state.go('user', { id: person.id });
                }

                return $state.go('contact', { id: person.id });
            }
        };

        $scope.onNewMessageBoxDescriptionChange = function ($event) {

            if ($event.description === '' && $scope.aiMessageBox) {
                $scope.aiMessageBox = false;
            }

            if ($scope.aiMessageBox) {
                $scope.aiQuestion = $event.aiQuestion;
            }
            else if ($event.aiQuestion !== null && angular.isDefined($event.aiQuestion)) {
                $scope.aiQuestion = $event.aiQuestion;
            }
            else {
                $scope.aiQuestion = null;
            }

            $scope.message.body = $event.description;
            $scope.message.mentions = $event.mentions;
            editingMessage = ($scope.message.body && $scope.message.body !== '');
        };

        $scope.sendQuestion = function sendQuestion() {

            return $scope.checkAICredits().then(() => {

                if (flagsService.get('showTimelineAiFeature')) {
                    flagsService.set('showTimelineAiFeature', false);
                }

                if ($scope.aiQuestion.length > 1000) {
                    utils.showErrorToast($translate.instant('Please ask a shorter question (max. 1000 characters)') || 'Please ask a shorter question (max. 1000 characters)');

                    return;
                }

                if (!$scope.message.body || $scope.message.body === '') {
                    return;
                }

                $scope.loadingAIMessage = true;

                const date = new Date().toISOString();
                $scope.feed.push({
                    description: $scope.message.body,
                    message_type: 'ai_question',
                    type: 'message',
                    id: `q_${date}`,
                    person: $scope.model.me,
                    time: date
                });


                return triggerQuestion();
            }).catch((err) => {
                utils.showErrorToast(err.data.message);
            });
        };

        $scope.submitMessage = function submitMessage() {

            if ($scope.aiMessageBox || $scope.aiQuestion) {
                return $scope.sendQuestion();
            }
            else {
                return $scope.createMessage();
            }
        };

        $scope.createMessage = function createMessage() {

            if (!$scope.message.body || $scope.message.body === '') {
                return;
            }

            const messageClone = angular.copy($scope.message);

            $scope.message.body = '';
            $scope.message.mentions = [];

            return messageService.create(messageClone).then(function () {

                editingMessage = false;
                getFeedAfter(true);
                $rootScope.$broadcast(events.account.updated, { fetchFeed: false });
            });
        };

        $scope.onMessageDescriptionChange = function ($event, interaction) {

            interaction.body = $event.description;
            interaction.mentions = $event.mentions;

            editingMessage = (interaction.body && interaction.body !== '');
        };

        $scope.editMessage = function (interaction) {

            if (!interaction.body) {
                return;
            }

            const messageClone = {
                body: interaction.body,
                mentions: interaction.mentions,
                account: $scope.account.id
            };

            return messageService.update(interaction.id, messageClone).then(function () {

                editingMessage = false;

                interaction.editing = false; // Hide editor and show message again
                interaction.description = interaction.body; // Update message's description, the one that shows in the feed (body is from the editor)

                $rootScope.$broadcast(events.account.updated, { fetchFeed: false });
            });
        };

        // This allows the listItemDetail to expand downwards
        $scope.showHideFullHeader = function ($event) {

            const listItemDetail = angular.element($event.currentTarget).find('.list-item-detail');

            listItemDetail.toggleClass('ellipsis');
            listItemDetail.css({ 'whiteSpace': listItemDetail.css('white-space') === 'normal' ? 'nowrap' : 'normal' });
        };

        $scope.showHideDetail = async function (interaction) {

            let detail = $scope.feedDetails[interaction.type + interaction.id];

            if (detail) {
                detail.show = !detail.show;
            }
            else {
                $scope.feedDetails[interaction.type + interaction.id] = interaction;

                detail = $scope.feedDetails[interaction.type + interaction.id];
                detail.id = interaction.id;
                detail.show = true;

                if (interaction.type === 'email') {
                    detail.email.addresses.allTo = (interaction.email.addresses.to || []);

                    if (interaction.email.addresses.cc) {
                        detail.email.addresses.allTo = [...detail.email.addresses.allTo, ...interaction.email.addresses.cc];
                    }

                    detail.email.addresses.allTo = detail.email.addresses.allTo.map(function (toRecipient) {

                        if (toRecipient.name) {
                            return `${toRecipient.name} <${toRecipient.email}>`;
                        }

                        return toRecipient.email;
                    }).join(', ');

                    let htmlBody = detail.email.body && getBody(detail.email.body, 'text/html');

                    /*
                     * For performance reasons the body is not included for IMAP emails and attachments are not included for O365 emails
                     * We fetch them on click to not slow down the timeline
                     */
                    let fullEmail = detail.email;
                    const shouldFetchMessage = !detail.email.body
                        || (detail.email.service_type === 'office365' && (detail.attachments || htmlBody?.includes('cid:')));

                    if (shouldFetchMessage) {
                        let messageResponse;
                        try {
                            messageResponse = await datasources.getMessage(interaction.data_source_id, interaction.id, { noToast: true });
                            fullEmail = messageResponse.data;
                            htmlBody = getBody(fullEmail.body, 'text/html');
                        }
                        catch {
                            if (!fullEmail.body) {
                                fullEmail.body = [{ type: 'text/html', content: '<div style="padding: 16px; border: 1px solid #8b0000; background-color: rgba(139, 0, 0, 0.15);"><span style="color:#8b0000;">The email was not found.</span><div>' },
                                    { type: 'text/plain', content: 'The email was not found.' }];
                                htmlBody = detail.email.body && getBody(detail.email.body, 'text/html');
                            }
                        }
                    }

                    detail.email.text_body = getBody(fullEmail.body, 'text/plain');

                    if (htmlBody) {
                        detail.email.html = true;

                        // Open links in separate window
                        htmlBody = htmlBody.replace(/<a/g, '<a target="_blank" ');

                        detail.email.html_body = htmlBody;
                    }

                    detail.email.files = fullEmail.files;

                    for (let i = detail.email.files.length - 1; i >= 0; --i) {
                        if (detail.email.files[i].is_embedded) {
                            detail.email.files.splice(i, 1);
                        }
                    }

                    detail.loaded = true;
                }
                else if (interaction.type === 'meeting-live' || interaction.type === 'meeting-phone' || interaction.type === 'meeting') {
                    return meeting.get(interaction.id, true).then(function (response) {

                        // eslint-disable-next-line no-shadow
                        const meeting = response.data;

                        if (meeting.notes) {
                            meeting.notes = fixLinks(meeting.notes);
                        }

                        if (meeting.description) {
                            meeting.description = fixLinks(meeting.description);
                        }

                        detail.meeting = meeting;
                        detail.loaded = true;
                    });
                }
                else if (interaction.type === 'webpage') {
                    return interactiongroup.get(interaction.id).then(function (response) {

                        detail.pages = response.data;
                        detail.max_duration = Math.max(...response.data.map(function (page) {

                            return page.duration;
                        }));

                        let tempTotal = 0;
                        for (let i = 0; i < response.data.length; ++i) {
                            tempTotal += response.data[i].duration;
                        }

                        detail.total_duration = tempTotal;
                        detail.totalDurationDescription = detail.total_duration < 60 * 1000 ? (detail.total_duration < 1000 ? '' : 'seconds') : 'minutes';
                        detail.loaded = true;
                    });
                }
                else if (interaction.type === 'forward') {
                    return interactiongroup.get(interaction.id).then(function (response) {

                        detail.pages = response.data;
                        detail.loaded = true;
                    });
                }
            }
        };

        $scope.strip = function (html) {

            const element = new DOMParser().parseFromString(html, 'text/html').firstChild;
            element.querySelectorAll('li').forEach(function (elem) {
                elem.outerHTML = '<div> ' + elem.innerHTML + '</div>';
            });

            element.querySelectorAll('div, p').forEach(function (elem) {
                elem.innerHTML = ' ' + elem.innerHTML;
            });

            return element.textContent || '';
        };

        function fixLinks(html) {

            const element = new DOMParser().parseFromString(html, 'text/html').firstChild;
            element.querySelectorAll('a').forEach(function (a) {
                a.setAttribute('target', '_blank');
                a.setAttribute('rel', 'noopener');
            });

            return element.innerHTML;
        }

        function getBody(bodies, type) {

            const body = bodies.find(function (item) {

                return (item.type === type);
            });

            if (body) {
                return body.content;
            }

            return null;
        }

        $scope.removeEmail = function (index, mail, $event) {

            $event.stopPropagation();
            $scope.feed.splice(index, 1);

            return account.removeEmail($scope.account.id, mail.email_message_id).then(function () {

                return $rootScope.$broadcast(events.account.updated);
            });
        };

        $scope.openMenuOnTouch = function ($event) {

            if ($window.touch) {
                $timeout(function () {

                    return angular.element($event.target).siblings('md-menu').children('md-icon').click();
                }, 0, false);
            }
        };

        $scope.showDeleteMessageDialog = function (index, message) {

            const confirm = $mdDialog.confirm()
                .clickOutsideToClose(true)
                .textContent($translate.instant('Are you sure you want to delete this message?') || 'Are you sure you want to delete this message?')
                .ok($translate.instant('Yes') || 'Yes')
                .cancel($translate.instant('No') || 'No');
            return $mdDialog.show(confirm).then(function () {

                $scope.feed.splice(index, 1);

                return messageService.remove(message.id).then(function () {

                    if ($mdMedia('gt-sm')) {
                        $rootScope.$broadcast(events.account.updated);
                        return $mdDialog.hide();
                    }

                    return $rootScope.$broadcast(events.account.updated);
                });
            });
        };

        $scope.showFeedbackDialog = function (index, message) {

            return $mdDialog.show(
                {
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    templateUrl: 'app-ajs/components/accountfeed/feedbackDialog/feedbackDialog.html',
                    // eslint-disable-next-line no-shadow
                    controller: ($scope, $mdDialog, $translate) => {
                        // We need to pass a model for the textarea to bind to
                        $scope.feedback = '';  // This is the variable bound to the textarea
                        $scope.feedbackPlaceholder = $translate.instant('Enter your feedback here');

                        // Handling Submit Button
                        $scope.submit = function () {
                            if (!$scope.feedback) {
                                $mdDialog.cancel();
                            }

                            $mdDialog.hide($scope.feedback);  // Passing the feedback to the caller
                        };

                        // Handling Cancel Button
                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };
                    }
                }
            ).then(function (text) {

                return messageService.addFeedback(message.id, { feedback: text }).then(function () {

                    if ($mdMedia('gt-sm')) {
                        $rootScope.$broadcast(events.account.updated);
                        return $mdDialog.hide();
                    }

                    return $rootScope.$broadcast(events.account.updated);
                });
            });
        };

        $scope.copyToClipboard = async function (textToCopy) {
            try {
                await navigator.clipboard.writeText(textToCopy);
            }
            catch (err) {
                alert('Failed to copy text: ' + err);
            }
        };

        $scope.reply = function reply(mail, $event) {

            $event.stopPropagation();

            return email.compose(email.formatRawEmailToComposeObject('reply', mail), 'reply');
        };

        $scope.replyAll = function replyAll(mail, $event) {

            $event.stopPropagation();

            return email.compose(email.formatRawEmailToComposeObject('replyAll', mail), 'replyAll');
        };

        $scope.forward = function forward(mail, $event) {

            $event.stopPropagation();

            return email.compose(email.formatRawEmailToComposeObject('forward', mail), 'forward');
        };

        $scope.nameTranslations = {
            'Someone': $translate.instant('Someone')
        };

        $scope.getNameTranslation = function getNameTranslation(name) {
            return $scope.nameTranslations[name] || name;
        };

        $scope.getMeetingTranslation = function getMeetingTranslation(interaction) {
            return ' ' + $translate.instant('with {{user}}', { user: $scope.getNameTranslation(interaction.person.name) });
        };

        $scope.feedTranslations = {
            'Nothing happened yet': () => $translate.instant('Nothing happened yet'),
            '(no subject)': () => $translate.instant('(no subject)'),
            'opened {{subject}}': (param) => $translate.instant('opened {{subject}}', { subject: param[0] }),
            ' called with {{name}}': (param) => ` ${$translate.instant('called with {{name}}', { name: param[0] })}`,
            ' called {{name}}': (param) => ` ${$translate.instant('called {{name}}', { name: param[0] })}`,
            ' failed to reach {{name}}': (param) => ` ${$translate.instant('failed to reach {{name}}', { name: param[0] })}`,
            'visited {{urls}}': (param) => $translate.instant('visited {{urls}}', { urls: param[0] }),
            'visited {{titles}} on {{urls}}': (param) => $translate.instant('visited {{titles}} on {{urls}}', { titles: param[0], urls: param[1] }),
            'joined the team': () => $translate.instant('joined the team'),
            'left the team': () => $translate.instant('left the team'),
            'added themself to the team': () => $translate.instant('added themself to the team'),
            'removed themself to the team': () => $translate.instant('removed themself to the team'),
            'was added to the team by {{name}}': (param) => $translate.instant('was added to the team by {{name}}', { name: param[0] }),
            'was removed from the team by {{name}}': (param) => $translate.instant('was removed from the team by {{name}}', { name: param[0] }),
            ' created {{name}}': (param) => ` ${$translate.instant('created {{name}}', { name: param[0] })}`,
            'Welcome to your first account. We have added our contact details for you, so you can always easily reach us. All emails, meetings, calls, ... with us will automatically appear in this timeline.': () => $translate.instant('Welcome to your first account. We have added our contact details for you, so you can always easily reach us. All emails, meetings, calls, ... with us will automatically appear in this timeline.')
        };

        $scope.getFeedTranslation = (interaction) => {
            if (interaction.descriptionTranslation) {
                return $scope.feedTranslations[interaction.descriptionTranslation](interaction.descriptionParam);
            }
            else if ($scope.feedTranslations[interaction.description]) {
                return $scope.feedTranslations[interaction.description]();
            }

            return interaction.description;
        };

        $scope.getFeedBefore = function getFeedBefore() {

            let before;

            if ($scope.feed.length > 0) {
                before = $scope.feed[0].time;
            }

            $scope.everythingLoaded = false;
            $scope.nothingMore = false;
            // We want to prevent that people spam the 'Load More' button
            // It might trigger the same getFeed call twice, causing ng-repeat to throw duplicate errors
            $scope.loadingMore = true;

            return account.getFeed($stateParams.id, { before, types: getFilterTypes(), contacts: getFilterContacts() }).then(function (response) {

                if (!response.data || response.data.length < 10) {
                    $scope.everythingLoaded = true;
                    $scope.nothingMore = true;
                }

                $scope.feed = [...response.data, ...$scope.feed].filter((entry, idx, arr) => {
                    return arr.findIndex((d) => d.id === entry.id && d.type === entry.type) === idx;
                });

                $scope.loadingMore = false;
            }).catch(function () {

                $scope.loadingMore = false;
            });
        };

        $scope.hideElement = sfWalkthrough.hideElement;

        $scope.isWalkthroughShowing = sfWalkthrough.isShowing;

        $scope.getCurrentWalkthroughStepId = sfWalkthrough.getCurrentStepId;

        function handleStream(eventSourceUrl, strategy) {
            if (strategy === 'fetch-event-source') {
                return handleFetchEventSourceStream(eventSourceUrl);
            }

            return handleEventSourceStream(eventSourceUrl);
        }

        /**
         * Creates a batched renderer for a streamed AI message.
         *
         * Stream callbacks (EventSource / fetch-event-source) run outside the AngularJS digest,
         * so every UI update has to be scheduled explicitly. Incoming chunks are accumulated in a
         * plain string and rendered to Markdown at most once per `STREAM_RENDER_INTERVAL`, inside a
         * `$timeout` so a digest runs for each batch. Rendering the full accumulated text each time
         * keeps the formatting independent of where the server happened to split the SSE chunks.
         * The resulting HTML is still sanitized by `ng-bind-html` in the template.
         *
         * @param {Object} interaction feed entry whose `description` receives the rendered HTML
         * @returns {{ append: Function, finish: Function, cancel: Function }}
         */
        function createStreamRenderer(interaction) {

            if (activeStreamRenderer) {
                activeStreamRenderer.cancel();
            }

            let rawSummary = '';

            let pendingRender = null;

            let finished = false;

            function render() {

                pendingRender = null;

                // Cleared in the same digest that shows the first text so the loading indicator never leaves a blank card
                $scope.loadingAIMessage = false;

                // Trailing newline lets marked close a list item or paragraph that is still being streamed
                interaction.description = marked(rawSummary + '\n');

                const lastInteractionElement = angular.element('#feed .message').last()[0];

                if (lastInteractionElement) {
                    utils.scrollIntoView(lastInteractionElement);
                }
            }

            function cancel() {

                if (pendingRender) {
                    $timeout.cancel(pendingRender);
                    pendingRender = null;
                }
            }

            /**
             * Buffers a chunk of streamed text and schedules a batched render.
             *
             * @param {String} text
             */
            function append(text) {

                if (!text || finished) {
                    return;
                }

                rawSummary += text;

                if (!pendingRender) {
                    pendingRender = $timeout(render, STREAM_RENDER_INTERVAL);
                }
            }

            /**
             * Flushes any buffered text, runs `onFinish` and applies everything in one digest.
             * Only the first call has an effect; later calls and appends are ignored.
             *
             * @param {Function} [onFinish] state updates to apply together with the final render
             */
            function finish(onFinish) {

                // The server sends its own 'end' event (carrying the message id) and susie appends a second, empty
                // 'end' event when closing the stream. Only the first one may complete the renderer, otherwise the
                // second call would cancel the pending final render and the id would never be applied.
                if (finished) {
                    return;
                }

                finished = true;

                cancel();

                // Tracked so cancel() can also drop the final render on $destroy or when a new stream starts
                pendingRender = $timeout(() => {
                    render();

                    if (onFinish) {
                        onFinish();
                    }
                });
            }

            activeStreamRenderer = {
                append,
                finish,
                cancel
            };

            return activeStreamRenderer;
        }

        function handleEventSourceStream(eventSourceUrl) {

            const interaction = $scope.feed[$scope.feed.length - 1];

            const renderer = createStreamRenderer(interaction);

            const eventSource = new EventSource(eventSourceUrl, { withCredentials: true });

            eventSource.addEventListener('end', () => {
                eventSource.close();

                renderer.finish(() => {
                    $scope.message.body = '';

                    $scope.aiButtonsDisabled = false;

                    interaction.live = false;
                });
            });

            eventSource.addEventListener('message', (event) => {
                renderer.append(angular.fromJson(event.data));
            });

            eventSource.addEventListener('error', () => {
                eventSource.close();
                renderer.finish();
            });

            return eventSource;
        }

        $scope.getMessageRequester = (interaction) => {
            if (interaction.message_type === 'answer') {
                return '';
            }

            return ($translate.instant('requested by') || 'requested by') + ` ${interaction.person.name} - `;
        };

        function handleFetchEventSourceStream(eventSourceUrl) {

            const interaction = $scope.feed[$scope.feed.length - 1];

            const renderer = createStreamRenderer(interaction);

            if (controller) {
                controller.abort();
            }

            controller = new AbortController();

            const streamController = controller;

            (async () => {
                let retries = 0;
                const maxRetries = 3;

                const { fetchEventSource } = await import('@microsoft/fetch-event-source');

                fetchEventSource(eventSourceUrl, {
                    signal: streamController.signal,
                    ...model.eventSourceAuthSettings(),
                    onmessage: (event) => {

                        if (event.event === 'end') {
                            streamController.abort();

                            renderer.finish(() => {
                                $scope.message.body = '';

                                $scope.aiButtonsDisabled = false;

                                interaction.live = false;

                                if (event.data) {
                                    interaction.id = event.data;
                                }
                            });

                            return;
                        }

                        if (event.data) {
                            renderer.append(angular.fromJson(event.data));
                        }
                    },
                    onerror: (err) => {
                        retries++;

                        if (retries >= maxRetries) {
                            streamController.abort();
                            renderer.finish();
                            return;
                        }

                        throw err;
                    }
                });
            })();
        }

        $scope.checkAICredits = () => {
            return account.checkAICredits();
        };

        $scope.summarizeTimeline = () => {

            return $scope.checkAICredits().then(() => {

                if (flagsService.get('showTimelineAiFeature')) {
                    flagsService.set('showTimelineAiFeature', false);
                }

                $scope.loadingAIMessage = true;

                const eventSourceUrl = config.apiUrl + 'accounts/' + $stateParams.id + '/summarize';

                const date = new Date().toISOString();
                $scope.feed.push({
                    description: '',
                    message_type: 'summary',
                    type: 'message',
                    id: `id_${date}`,
                    live: true,
                    time: date,
                    person: $scope.model.me
                });

                // eslint-disable-next-line angular/timeout-service
                setTimeout(() => {
                    const lastInteractionElement = angular.element('#feed .message').last()[0];
                    utils.scrollIntoView(lastInteractionElement);
                }, 500);

                $scope.aiButtonsDisabled = true;

                return handleStream(eventSourceUrl, 'fetch-event-source');
            }).catch((err) => {
                utils.showErrorToast(err.data.message);
            });
        };

        $scope.listNextSteps = () => {

            return $scope.checkAICredits().then(() => {

                if (flagsService.get('showTimelineAiFeature')) {
                    flagsService.set('showTimelineAiFeature', false);
                }

                $scope.loadingAIMessage = true;

                const eventSourceUrl = config.apiUrl + 'accounts/' + $stateParams.id + '/nextsteps';

                const date = new Date().toISOString();
                $scope.feed.push({
                    description: '',
                    message_type: 'nextsteps',
                    type: 'message',
                    id: `id_${date}`,
                    live: true,
                    time: date,
                    person: $scope.model.me
                });

                // eslint-disable-next-line angular/timeout-service
                setTimeout(() => {
                    const lastInteractionElement = angular.element('#feed .message').last()[0];
                    utils.scrollIntoView(lastInteractionElement);
                }, 500);

                $scope.aiButtonsDisabled = true;

                return handleStream(eventSourceUrl, 'fetch-event-source');
            }).catch((err) => {
                utils.showErrorToast(err.data.message);
            });
        };

        $scope.askQuestion = () => {
            $scope.messageBoxPlaceholder = $translate.instant('Ask a question...') || 'Ask a question...';
            $scope.aiMessageBox = true;
        };

        $scope.getTeamUpdateText = function (interaction) {
            if (interaction.descriptionTranslation) {
                return $scope.feedTranslations[interaction.descriptionTranslation](interaction.descriptionParam);
            }
            else if (interaction.description && $scope.feedTranslations[interaction.description]) {
                return $scope.feedTranslations[interaction.description]();
            }

            return interaction.description;
        };

        function triggerQuestion() {

            const params = new URLSearchParams({
                question: $scope.aiQuestion,
                ai_question: $scope.message.body
            }).toString();

            const eventSourceUrl = config.apiUrl + 'accounts/' + $stateParams.id + '/askQuestion?' + params;

            const date = new Date().toISOString();
            $scope.feed.push({
                description: '',
                message_type: 'ask',
                type: 'message',
                id: `a_${date}`,
                live: true,
                time: date,
                person: $scope.model.me
            });

            // eslint-disable-next-line angular/timeout-service
            setTimeout(() => {
                const lastInteractionElement = angular.element('#feed .message').last()[0];
                utils.scrollIntoView(lastInteractionElement);
            }, 500);

            $scope.aiMessageBox = false;

            $scope.message.body = '';

            $scope.aiButtonsDisabled = true;

            return handleStream(eventSourceUrl, 'fetch-event-source');
        }

        const removeStartTransitionHook = $transitions.onStart({}, (transition) => {

            if (!editingMessage) {
                return;
            }

            const toState = transition.to();
            const toParams = transition.params('to');

            return sfDiscardDialog.show(false, {}).then(function () {
                editingMessage = false;
                return $state.go(toState, toParams);
            }).catch(() => {
                transition.abort();
            });
        });

        $scope.showFeedWarningMessage = () => {

            if (!$scope.account) {
                return false;
            }

            return (getFilterContacts() || $scope.account.customers).length > 50;
        };

        $scope.showTimelineAI = function () {

            return flagsService.get('showTimelineAI');
        };

        $scope.showTimeLineAiWalkthrough = function () {
            return flagsService.get('showTimelineAiWalkthrough');
        };

        $scope.showTimeLineAiFeatureDots = function () {
            return flagsService.get('showTimelineAiFeature');
        };

        $scope.$on('$destroy', function () {

            if (activeStreamRenderer) {
                activeStreamRenderer.cancel();
            }

            if (controller) {
                controller.abort();
            }

            if (timelineAiTour) {
                try {
                    timelineAiTour.cancel();
                }
                catch {
                    // Noop
                }

                timelineAiTour = null;
            }

            removeStartTransitionHook();
        });

        function getFeedAfter(scrollDown) {

            let after;

            if ($scope.feed && $scope.feed.length > 0) {
                after = $scope.feed[$scope.feed.length - 1].time;
            }

            return account.getFeed($stateParams.id, { after, types: getFilterTypes(), contacts: getFilterContacts() }, true).then(function (response) {

                if (response.data.length === 0) {
                    return;
                }

                // If an interaction was updated replace otherwise just add to feed
                for (let i = 0; i < response.data.length; ++i) {
                    const newInteraction = response.data[i];
                    let shared = false;

                    for (let j = 0; j < $scope.feed.length; ++j) {
                        const oldInteraction = $scope.feed[j];

                        if (newInteraction.type + newInteraction.id === oldInteraction.type + oldInteraction.id) {
                            $scope.feed[j] = newInteraction;
                            shared = true;

                            break;
                        }
                    }

                    if (!shared) {
                        $scope.feed.push(newInteraction);
                    }
                }

                if (scrollDown) {

                    // Scroll to bottom of the feed
                    return $timeout(function () {

                        const lastInteractionElement = angular.element('#feed .interaction, #feed .message, #feed .team-update').last()[0];

                        if (lastInteractionElement) {
                            utils.scrollIntoView(lastInteractionElement);
                        }
                    }, 100);
                }
            });
        }

        function reload() {

            let limit;

            if (!$scope.feed || $scope.feed.length < 10) {
                limit = 10;
            }
            else {
                limit = $scope.feed.length;
            }

            return get(limit, true);
        }

        function get(limit, ignoreLoadingBar) {

            $scope.loading = true;

            if (!$scope.account || !$scope.account.part_of) {
                $scope.loading = false;
                return;
            }

            return account.getFeed($stateParams.id, { limit, types: getFilterTypes(), contacts: getFilterContacts(), canceler: 'feed-' + $stateParams.id }, ignoreLoadingBar).then(function (response) {

                $scope.loading = false;
                $scope.feed = response.data;

                if (!response.data || response.data.length < 10) {
                    $scope.everythingLoaded = true;
                }

                // Scroll to bottom of the feed when this is our first get
                if (!limit) {
                    $timeout(function () {

                        const feedInteraction = angular.element('#feed .interaction, #feed .message, #feed .team-update').last()[0] || null;

                        if (feedInteraction) {
                            utils.scrollIntoView(feedInteraction);
                        }
                    }, 100, false);
                }

                // Refresh meeting detail data since meeting could have been updated
                /*eslint no-loop-func: 0*/
                for (const key in $scope.feedDetails) {
                    const detail = $scope.feedDetails[key];

                    if (detail.type === 'meeting-live' || detail.type === 'meeting-phone' || detail.type === 'meeting') {

                        // Make sure it is still in the feed
                        for (let i = 0; i < response.data.length; ++i) {
                            const feedElement = response.data[i];

                            if (feedElement.id === detail.id && feedElement.type === detail.type) {
                                meeting.get(detail.id, true).then(function (meetingResponse) {

                                    detail.meeting = meetingResponse.data;
                                });
                            }
                        }
                    }
                }
            }, null, function (response) {

                $scope.loading = false;
                $scope.feed = response.data;

                if (!response.data || response.data.length < 10) {
                    $scope.everythingLoaded = true;
                }

                // Scroll to bottom of the feed when this is our first get
                if (!limit) {
                    $timeout(function () {

                        const feedInteraction = angular.element('#feed .interaction').last()[0] || null;

                        if (feedInteraction) {
                            utils.scrollIntoView(feedInteraction);
                        }
                    }, 100, false);
                }
            });
        }

        function init() {

            // Fill in customers filter now that we have the account
            const fetchedCustomerFilter = filterService.getAccountFeedCustomersFilter($scope.account.id) || $scope.account.customers.map(function (customer) {

                return customer.id;
            });

            /**
             * Fix for https://github.com/Salesflare/Server/issues/7145
             * There was an issue where we stored the wrong filter for an account with contacts from another account.
             * So we need to make sure that the customer filter only includes contacts that are actually in the account.
             *
             * Since we modify `$scope.feedFilterCustomers` later on with this list, it will trigger the `feedFilterCustomers` watch.
             * It will set the filter in local storage correctly for us.
             */
            let customerFilter = fetchedCustomerFilter.filter(function (customerId) {

                return $scope.account.customers.some(function (customer) {

                    return String(customer.id) === customerId;
                });
            });

            // If we end up with no customers and we made changes with our fix, default to all the customers of the account.
            if (customerFilter.length === 0 && customerFilter.length !== fetchedCustomerFilter.length) {
                customerFilter = $scope.account.customers.map(function (customer) {

                    return customer.id;
                });
            }

            customerFilter.forEach(function (customerId) {

                $scope.feedFilterCustomers[customerId] = true;
            });

            // We have to manually set excluded customers to false, otherwise the local storage will get overwritten later with undefined. Which would remove the filter by the next page visit
            const excludedCustomers = $scope.account.customers.filter(function (customer) {

                // Only return customers not currently listed in the feed customer filter
                return !$scope.feedFilterCustomers[customer.id];
            }).map(function (customer) {

                return customer.id;
            });

            excludedCustomers.forEach(function (customerId) {

                $scope.feedFilterCustomers[customerId] = $scope.feedFilterCustomers[customerId] ? true : false;
            });

            if ($scope.account.part_of) {
                $scope.loading = true;
                // Normally we would load the feed here.
                // But since we modified/set up the customer filter the `feedFilterCustomers` watch will trigger.
                // That watch will, in turn, trigger `get`.
                // If we would already fetch the feed here, we would fetch it twice for no reason.
            }
            else if (model.me.is_admin) {
                $scope.requestAccessText = $translate.instant('Add yourself to the {{accountName}} team to see the timeline here.', { accountName: $scope.account.name }) || `Add yourself to the ${$scope.account.name} team to see the timeline here.`;
            }
            else if (!model.me.is_admin) {
                $scope.requestAccessText = $translate.instant('To access this account timeline, ask your colleague(s) to add you to the team of the account.') || 'To access this account timeline, ask your colleague(s) to add you to the team of the account.';
            }

            if (flagsService.get('showTimelineAiWalkthrough')) {
                startTimelineAiTour();
            }
        }

        function startTimelineAiTour() {

            // Check if the leads walkthrough is currently active
            if (flagsService.get('showLeadsWalkthrough') && $mdMedia('gt-sm')) {
                // Wait a bit and check again
                $timeout(function () {
                    startTimelineAiTour();
                }, 3000);
                return;
            }

            // Delay to ensure FAB actions are rendered and positioned
            $timeout(function () {

                if (timelineAiTour || $scope.isWalkthroughShowing()) {
                    return;
                }

                timelineAiTour = new Shepherd.Tour({
                    defaultStepOptions: {
                        popperOptions: {
                            modifiers: [{ name: 'offset', options: { offset: [0, 10] } }]
                        }
                    }
                });

                // We only show the "NEW" prefix to users who created their account before the timeline AI release
                const userCreatedBeforeTimelineAiRelease = new Date(model.me.creation_date) < new Date('2025-08-14');

                timelineAiTour.addStep({
                    title: userCreatedBeforeTimelineAiRelease
                        ? ($translate.instant('NEW: Analyze your timeline using AI') || 'NEW: Analyze your timeline using AI')
                        : ($translate.instant('Analyze your timeline using AI') || 'Analyze your timeline using AI'),
                    text: $translate.instant('Summarize conversations, list next steps, and ask questions to quickly understand what\'s going on.') || 'Summarize conversations, list next steps, and ask questions to quickly understand what\'s going on.',
                    attachTo: {
                        element: 'md-fab-trigger:has(#feed-fab-speed-dial)',
                        on: 'right'
                    },
                    buttons: [{ action: timelineAiTour.next, text: $translate.instant('GOT IT') || 'GOT IT' }]
                });

                timelineAiTour.on('complete', function () {

                    flagsService.set('showTimelineAiWalkthrough', false);
                    timelineAiTour = null;
                });

                timelineAiTour.on('cancel', function () {

                    timelineAiTour = null;
                });

                timelineAiTour.start();

            }, 1000);
        }

        function getFilterTypes() {

            // Turn feedFilterInteractionTypes map into array of strings
            // We do some conversion here since the view model updated but we need to be backwards compatible
            const filterOptionKeys = Object.keys($scope.feedFilterInteractionTypes);
            return filterOptionKeys.map(function (option) {

                if ($scope.feedFilterInteractionTypes[option]) {
                    return option;
                }

                // eslint-disable-next-line unicorn/no-useless-undefined
                return undefined;
            }).reduce(function (types, option) {

                if (!option) {
                    return types;
                }

                return [...types, ...(angular.isArray(typesMap[option]) ? typesMap[option] : [typesMap[option]])];
            }, []);
        }

        function getFilterContacts() {

            const filterContacts = Object.keys($scope.feedFilterCustomers);
            const remainingContacts = filterContacts.filter(function (contactId) {

                return $scope.feedFilterCustomers[contactId];
            });

            if ($scope.account.customers.length === remainingContacts.length) {
                return;
            }

            return remainingContacts;
        }
    }
})();
